import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';

export default function BookmarkOutlineIcon(props) {
  return <FontAwesomeIcon icon={faBookmark} {...props} />;
}
